import { computed, ref } from '@vue/composition-api'
import notesCategories from './notes-categories'

export default function useSubmitNote(props, ctx) {
  const noteText = ref('')
  const notesFormRef = ref(null)
  const category = ref('Penalty')
  const submitBtnLoading = ref(false)
  const loggedUser = computed(() => ctx.root.$store.getters['auth/getLoggedUser'])
  const userId = ctx.root.$route.params.id

  const saveNote = async () => {
    const valid = await notesFormRef.value.validate()
    if (!valid) return
    try {
      submitBtnLoading.value = true
      await ctx.root.$store.dispatch('notes/addNote', {
        notableType: props.notableType,
        notableId: userId,
        note: noteText.value,
        addedBy: loggedUser.value.email,
        category: category.value,
      })
      ctx.emit('addedNote')
      noteText.value = ''
      notesFormRef.value.reset()
    } catch (error) {
      console.log(error)
    } finally {
      submitBtnLoading.value = false
    }
  }

  return {
    saveNote,
    submitBtnLoading,
    noteText,
    category,
    notesCategories,
    notesFormRef,
  }
}
